import { render, staticRenderFns } from "./SidebarOverlay.vue?vue&type=template&id=61803864&scoped=true&"
import script from "./SidebarOverlay.vue?vue&type=script&lang=ts&"
export * from "./SidebarOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-overlay.scss?vue&type=style&index=0&id=61803864&lang=scss&scoped=true&"
import style1 from "./SidebarOverlay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61803864",
  null
  
)

export default component.exports